import nextArrowIcon from '@/icons/next-arrow-icon.svg'
import usLabTestedIcon from '@/icons/us-lab-tested-icon.webp'
import easilyDissolvesIcon from '@/icons/easily-dissolves-icon.webp'
import noHarshChemicalsIcon from '@/icons/no-harsh-chemicals-icon.webp'
import powerfulCleanIcon from '@/icons/powerful-clean-icon.webp'
import checkIcon from '@/icons/check-icon.svg'
import ConfettiExplosion from 'react-confetti-explosion'
import { logInfo } from '@/utilities/log'
import { createPortal } from 'preact/compat'
import { getLocalizedStrings } from '@/localization/localization-store'
import withRootRoute from '@/localization/with-root-route'

export type QuizCompleteProps = {
  ctaButtonLabel?: string
  ctaButtonUrl?: string
  featuredImage?: {
    src: string
    alt?: string | null
  }
}

/* eslint-disable react/no-unescaped-entities */
export default function QuizComplete({
  ctaButtonLabel = 'Get My Discount',
  ctaButtonUrl = '/gwp',
  featuredImage
}: QuizCompleteProps): JSX.Element {
  const { storeRootRoute } = getLocalizedStrings()

  return (
    <div>
      <div className='mb-32 flex flex-col items-center gap-y-2 px-5vw pb-2 sm:gap-y-3 md:m-0'>
        <div className='rounded-xl bg-deep-ocean-blue p-2 text-xs font-medium leading-none text-crisp-white sm:text-sm'>
          You Unlocked Our Special Offer!
        </div>
        <h6 className='leading-tight md:text-3xl'>You get 40% OFF + 4 FREE Gifts!</h6>
        <p className='text-sm leading-tight md:text-base'>
          Instantly make your laundry routine{' '}
          <span className='font-bold'>free of harsh chemicals</span> with{' '}
          <span className='font-bold'>the same powerful clean</span> you're used to!
        </p>
        {featuredImage && (
          <div className='relative h-[25dvh] overflow-hidden  rounded lg:h-[28dvh]'>
            <img
              src={featuredImage.src}
              alt={featuredImage.alt ?? 'Eco-Friendly Detergent'}
              // eslint-disable-next-line tailwindcss/enforces-shorthand
              className='h-full w-full object-contain'
            />
          </div>
        )}
        <div className='grid max-w-110 grid-cols-4 gap-2'>
          <img src={usLabTestedIcon} alt='US Lab Tested' />
          <img src={easilyDissolvesIcon} alt='Easily Dissolves' />
          <img src={noHarshChemicalsIcon} alt='No Harsh Chemicals' />
          <img src={powerfulCleanIcon} alt='Powerful Clean' />
        </div>
        <div className='card max-w-192 border border-deep-ocean-blue/[.12] bg-[#fff5e3] md:p-8'>
          {' '}
          <p>
            <span className='font-bold uppercase text-error-red'>LIMITED TIME:</span> Make the
            switch to safer, and better for the planet detergent{' '}
            <span className='font-bold'>at an internet-only price.</span>
          </p>
          <p className='font-bold'>Up to 40% OFF + 4 FREE Gifts for new subscribers!</p>
        </div>
      </div>
      <div className='fixed bottom-0 mx-auto flex w-full flex-col gap-y-2 bg-cloud-white p-3 lg:static lg:w-max lg:bg-transparent'>
        <a
          href={withRootRoute(ctaButtonUrl, storeRootRoute)}
          onClick={() => logInfo('QuizResultCtaClicked')}>
          <button className='btn btn-square btn-fresh-scent w-full md:w-auto lg:px-20'>
            {ctaButtonLabel}
            <span className='ml-2 inline-block h-4 w-6'>
              <img src={nextArrowIcon} alt='Next Arrow' height={16} width={16} />
            </span>
          </button>
        </a>
        <span className='text-xs font-semibold text-fresh-scent'>
          <img src={checkIcon} alt='Check' className='mr-1 inline-block align-top' height={12} />
          VERIFIED LOWEST PRICE EVER
        </span>
      </div>
      {createPortal(
        <div className='absolute left-1/2 top-0 -translate-x-1/2'>
          <ConfettiExplosion particleCount={200} particleSize={8} />
        </div>,
        document.body
      )}
    </div>
  )
}
